import React from "react"
import { appPlayerProfilePath } from "../paths"
import { Round, TeamRound } from "../types"

interface TeamPlayersScreenProps {
  currentUserId: number
  round: Round
  teamRound: TeamRound
}

export default function TeamPlayersScreen({ currentUserId, round, teamRound }: TeamPlayersScreenProps) {
  const backPath = encodeURIComponent(`/app/league_rounds/${round.id}`)
  const profileBackPath = `/app/league_rounds/${round.id}`

  return (
    <>
      <div className="screen-heading" style={{ textAlign: "left" }}>
        <h1 className="screen-title">Manage Players</h1>
        {teamRound.players.length < 2 ? (
          <>
            <p>If you're not going to be able to play, remove or replace yourself with a sub.</p>
          </>
        ) : (
          <>
            <p>
              If your partner isn't going to be able to play, remove them or replace them with a sub before starting
              scoring.
            </p>
          </>
        )}
      </div>
      <div className="screen-body" style={{ borderTop: "1px solid #CCC", paddingTop: "1rem", textAlign: "left" }}>
        {teamRound.players
          .filter((p) => !p.canceled)
          .map((p) => {
            return (
              <div key={p.id} className="row" style={{ marginBottom: "1rem", display: "table", width: "100%" }}>
                <div className="player" style={{ display: "table-cell", verticalAlign: "middle", width: "50%" }}>
                  <a
                    href={appPlayerProfilePath(p.user.sqid, {
                      back_path: profileBackPath,
                      round_id: round.id,
                      league_id: round.league.id
                    })}
                  >
                    <strong>{p.user.name}</strong>
                  </a>
                  <br />
                  <span className="spark-orange" style={{ fontSize: "20px", fontWeight: "700" }}>
                    &bull;
                  </span>
                  &nbsp;
                  {p.handicapStrokes} {p.handicapStrokes === 1 ? "stroke" : "strokes"}
                </div>
                <div
                  className="buttons"
                  style={{
                    display: "table-cell",
                    verticalAlign: "middle",
                    width: "50%",
                    textAlign: "right",
                    borderBottom: "1px solid #efefef"
                  }}
                >
                  <a
                    href={`/app/league_rounds/${round.id}/${currentUserId === p.user.id ? "" : "partner_"}unregistration?back_path=${backPath}`}
                    className="action-button small border-only"
                  >
                    Unregister
                  </a>
                  <a
                    href={`/app/players/${p.id}/choose_substitute?back_path=${backPath}`}
                    className="action-button small border-only orange"
                    style={{ marginLeft: "1rem" }}
                  >
                    Sub
                  </a>
                </div>
              </div>
            )
          })}
      </div>
    </>
  )
}
